export const AGE = Object.freeze({ MAX_AGE: 120, MIN_AGE: 13 })
